// extracted by css-extract-rspack-plugin
export default {"root":"root-ZxNwXv","text":"text-TPH77k","title":"title-yznpj0 text-sm-semibold","subtitle":"subtitle-PF5yeq"};